import { Field } from "formik";
import { RowInput } from "../../FormElements";

export const ManageUserForm = ({ translate }) => {
  return (
    <>
      <Field
        label={translate("userEmail")}
        name={"email"}
        component={RowInput}
      />
      <Field
        label={translate("userFirstName")}
        name={"name"}
        component={RowInput}
      />
      <Field
        label={translate("userLastName")}
        name={"surname"}
        component={RowInput}
      />
    </>
  );
};
